var $ = jQuery;
jQuery(document).ready(function(){

    const aboutGallery = $("#gallery-slider");
    const textSlider = $("#text-slider");
    if(aboutGallery)
    {
            aboutGallery.slick({
                dots: false,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                arrows:true,
                prevArrow: $('.prev'),
                nextArrow: $('.next'),
                asNavFor: '#text-slider'
            });
            textSlider.slick({
                dots: false,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                arrows:false,
                asNavFor: '#gallery-slider'
            });

    }

    const caseStudySlider = $("#case-study-slider");
    const caseStudySliderMobile = $("#case-study-slider-mobile");

    if(caseStudySlider)
    {
        caseStudySlider.slick({
            dots: false,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows:true,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
        });
    }

    if(caseStudySliderMobile)
    {
        caseStudySliderMobile.slick({
            dots: false,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows:true,
            prevArrow: $('.prev.mobile'),
            nextArrow: $('.next.mobile'),
        });
    }

    const testimonialsSlider = $("#testimonials-slider");
    const testimonialsNameSlider = $("#testimonials-name-slider");

    if(testimonialsSlider)
    {
        testimonialsSlider.slick({
            dots: false,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows:true,
            prevArrow: $('.prev.testimonial'),
            nextArrow: $('.next.testimonial'),
            asNavFor: '#testimonials-name-slider'
        });

        testimonialsNameSlider.slick({
            dots: false,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows:false,
            asNavFor: '#testimonials-slider'
        })
    }

    const hamburger = $(".hamburger");
    const mobileMenu = $(".mobile-menu");
    const siteBody = $("body");
    const closeButton = $(".close");

    if(hamburger)
    {
        hamburger.click(function(e){
            e.preventDefault();
            mobileMenu.toggleClass("show");
            siteBody.toggleClass("menu-open");
        });
    }

    if(closeButton)
    {
        closeButton.click(function(e){
            e.preventDefault();
            mobileMenu.toggleClass("show");
            siteBody.toggleClass("menu-open");
        })
    }

});
